module.exports = __webpack_public_path__ + "img/04-xxl.974fb58.webp";